export const TimeOffset = () => (new Date()).getTimezoneOffset() * (-1) * 60;